import { CloseIcon } from 'assets/icons/CloseIcon'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { addWorkSchedulesAiRule } from 'features/work-schedules/workScheduleSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const AiRulesModal = ({ closeModal, value }: { closeModal: any, value: string }) => {
    const [rules, setRules] = useState(value)
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {
        const resp = await dispatch(addWorkSchedulesAiRule({ rule: rules }))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    return <Modal black>
        <Flex column between center height='50vh'>
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value ? 'Edit' : 'Add'} Rules</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input type='textarea' height='250px' placeholder='Input rule here...' labelText='Rules' value={rules} onChange={e => setRules(e.target.value)} nomarg />
            </Flex>
            <Button orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

